<svg class="sa-chevron sa-chevron--{{direction}}" viewBox="0 0 27 50">
    <path [attr.d]="directionPath"></path>
</svg>
